import React, { useState } from 'react';
import Wrapper from '../MentorShipHeaders/Wrapper';
import Table from './MenteesTable';
import { useNavigate, useParams } from 'react-router-dom';
import ViewMentee from './ViewMentee';

export default function () {
  let { uuid } = useParams();
  const [mode, setMode] = useState(uuid === undefined ? 'list' : 'single');
  const [action, setAction] = useState('view');
  let navigate = useNavigate();

  return (
    <Wrapper topBarActiveOption={'Events'} active="mentees">
      <div>
        <div>
          <Table
            mode={mode}
            callAction={(d, action) => {
              setMode('single');
              setAction(action);
              navigate(`/mentees/${d.uuid}`, {
                state: {
                  itemUuid: d?.uuid,
                },
              });
            }}
          />
          {mode === 'single' && (
            <div className="h-96 w-2/3 bg-gray-50">
              {action === 'view' && <ViewMentee menteeUuid={d.uuid} />}
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  );
}
